import React from 'react';
import { useSelector } from 'react-redux';

import { Controller, useFormContext } from 'react-hook-form';
import { MdClear, MdKeyboardArrowDown } from 'react-icons/md';
import Select from 'react-select';
import { selectStyle } from './SelectStyle';

const SpecificationSelect = ({ disabled, options, name, placeholder, label, autoFocus = false }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = options.map((option) => {
    return {
      label: option.displayName,
      value: option,
    };
  });

  return (
    <div>
      <label className="input-label">{label}</label>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            components={{
              DropdownIndicator: (props) => (
                <div>
                  <MdKeyboardArrowDown {...props.innerProps} />
                </div>
              ),
              IndicatorSeparator: () => null,
              ClearIndicator: (props) => (
                <div>
                  <MdClear {...props.innerProps} className="cursor-pointer mr-1" />
                </div>
              ),
            }}
            autoFocus={autoFocus}
            isClearable={true}
            isDisabled={disabled}
            value={value ? { label: value.displayName, value: value } : null}
            onChange={(selectedValue) => {
              onChange(selectedValue?.value || null);
            }}
            className="text-xs md:text-sm"
            placeholder={placeholder}
            options={selectOptions ? selectOptions : []}
            styles={selectStyle(isMobileView)}
          />
        )}
      />
      {errors[name] && <span className="text-xs text-contrast1 mt-1">{errors[name].message}</span>}
    </div>
  );
};
export default SpecificationSelect;
